export default {
  alreadyExists: "Ya existente",
  collapse: "Contraer",
  expand: "Expandir",
  remove: "Quitar",
  restore: "Volver a añadir",
  regenerate: "Regenerar",
  generating: "Generando contenido con IA...",
  themePlaceholder:
    "Ej: enfoque en sostenibilidad, innovación, vinculación con el medio...",
  themeHint:
    "Tema opcional para orientar la regeneración (máximo 200 caracteres).",
  themeInfo:
    "Opcional: escribe palabras clave o una orientación breve para guiar la regeneración; no necesitas redactar extenso. Ej.: “metodologías ágiles”, “con enfoque en sostenibilidad”, “trabajo colaborativo”.",
};
